module.exports = __webpack_public_path__ + "static/media/cart.46763b18.svg";